export var SerializedValueType;
(function (SerializedValueType) {
    SerializedValueType["Date"] = "Date";
    SerializedValueType["Set"] = "Set";
    SerializedValueType["Map"] = "Map";
})(SerializedValueType || (SerializedValueType = {}));
export const isSerializedValue = (object) => {
    return '_type_' in object && '_value_' in object;
};
